module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9KpBP"))).then(() => parcelRequire('hEqeo'));